var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVfaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vfa_Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 111.3 48.9",
    style: {
      enableBackground: "new 0 0 111.3 48.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.vfa-icon-st0{fill:#ED1B2F;}\r\n\t.vfa-icon-st1{fill:#D7182A;}\r\n\t.vfa-icon-st2{fill:#B10F1F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "vfa-icon-st0",
    d: "M44,32.3c0-0.1,0-0.3,0-0.4c0,0,0-0.1,0-0.1c-0.1-0.9-0.4-1.8-0.9-2.6l-0.1-0.3c-0.1-0.1-0.1-0.2-0.2-0.3 l-10.4-18c-0.2,0.6-0.5,1.2-0.8,1.8l-7.4,12.9l6.4,11.1c1.2,2.1,3.3,3.4,5.6,3.6h0.7c3.5,0,6.4-2.5,7.1-5.8c0,0,0,0,0,0 c0-0.2,0.1-0.4,0.1-0.6c0-0.1,0-0.1,0-0.2c0-0.2,0-0.3,0-0.5c0-0.1,0-0.2,0-0.3C44,32.5,44,32.4,44,32.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "vfa-icon-st1",
    d: "M15.8,10.9L22,21.7l6.3-10.9c1.9-3.2,0.9-7.3-2-9.5c-0.1,0-0.1-0.1-0.2-0.1C26,1.2,25.9,1.1,25.7,1 c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.3-0.1-0.5-0.2 c0,0-0.1,0-0.1,0c-0.2,0-0.3-0.1-0.5-0.1c-0.1,0-0.1,0-0.2,0c-0.2,0-0.3,0-0.5-0.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.3,0-0.4,0 c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0-0.5,0.1c-0.1,0-0.1,0-0.2,0c-0.2,0-0.3,0.1-0.5,0.1c0,0-0.1,0-0.1,0 c-0.2,0-0.3,0.1-0.5,0.2c-0.1,0-0.1,0-0.2,0.1c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0-0.2,0.1-0.3,0.1C18.5,0.9,18.4,1,18.3,1 c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0-0.1,0.1-0.2,0.1C14.8,3.5,13.9,7.6,15.8,10.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "vfa-icon-st2",
    d: "M0,32.3c0-0.1,0-0.3,0-0.4c0,0,0-0.1,0-0.1C0.2,30.9,0.5,30,1,29.2l0.1-0.3c0.1-0.1,0.1-0.2,0.2-0.3l10.4-18 c0.2,0.6,0.5,1.2,0.8,1.8l7.4,12.9l-6.4,11.1c-1.2,2.1-3.3,3.4-5.6,3.6H7.2c-3.5,0-6.4-2.5-7.1-5.8c0,0,0,0,0,0 c0-0.2-0.1-0.4-0.1-0.6c0-0.1,0-0.1,0-0.2c0-0.2,0-0.3,0-0.5c0-0.1,0-0.2,0-0.3C0,32.5,0,32.4,0,32.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "vfa-icon-st2",
    d: "M68.6,10.8h5.3l-7.2,20.4h-6.2l-7.2-20.4h5.3l5.1,15.4L68.6,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "vfa-icon-st2",
    d: "M76,10.8h13.3v4h-8.3v4.3h6.2V23h-6.2v8.3h-5V10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "vfa-icon-st2",
    d: "M104.6,27.6H97l-1.2,3.6h-5.2l7.4-20.4h5.8l7.4,20.4h-5.3L104.6,27.6z M100.8,16.3l-2.5,7.5h5L100.8,16.3z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVfaIcon);
export default __webpack_public_path__ + "static/media/VfaIcon.0dcb18ea.svg";
export { ForwardRef as ReactComponent };